module.exports = __webpack_public_path__ + "app/components/global-search/global-search.view.html";